module.exports = __webpack_public_path__ + "img/webmag-signup.9c25bf3c.png";